@if ((message$ | async) != null) {
    <div class="content text-center default-icon-color">
        <div class="vertical-centering default-icon-color">
            <i class="fas fa-info-circle fa-7x"></i>
            <div class="no-records-message">{{ 'error.message' | translation | async }}</div>
            <div class="no-records-message-detail">{{ message$ | async }}</div>
        </div>
    </div>
}
